import type { LucideIcon } from 'lucide-react';

interface StatCardProps {
  label: string;
  value: string | number;
  icon: LucideIcon;
  trend?: { value: number; positive: boolean };
  caption?: string;
  loading?: boolean;
  onClick?: () => void;
}

export function StatCard({
  label,
  value,
  icon: Icon,
  trend,
  caption,
  loading,
  onClick,
}: StatCardProps) {
  if (loading) {
    return (
      <div className="bg-surface rounded-xl border border-border p-5 animate-pulse">
        <div className="h-4 bg-border rounded w-24 mb-3" />
        <div className="h-8 bg-border rounded w-16" />
      </div>
    );
  }

  const Wrapper = onClick ? 'button' : 'div';

  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`bg-surface rounded-xl border border-border p-5 hover:border-border-hover transition-colors text-left w-full ${onClick ? 'cursor-pointer hover:bg-surface-hover' : ''}`}
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm text-text-secondary">{label}</span>
        <Icon size={18} className="text-text-muted" />
      </div>
      <div className="text-2xl font-semibold text-text">
        {typeof value === 'number' ? value.toLocaleString() : value}
      </div>
      {caption && <div className="text-xs text-text-muted mt-1">{caption}</div>}
      {trend && (
        <div className={`text-xs mt-1 ${trend.positive ? 'text-success' : 'text-danger'}`}>
          {trend.positive ? '+' : ''}
          {trend.value}% from last month
        </div>
      )}
    </Wrapper>
  );
}
